import getConfig from 'next/config'

const useLocalePath = () => {
  const localePath = (path, isChangePath) => {
    if (!isChangePath) return path
    const baseUrl = `https://${getConfig().publicRuntimeConfig.baseDomain}`

    return `${baseUrl}${path}`
  }

  return {
    localePath,
  }
}

export default useLocalePath
